import React, { useState, useEffect } from "react";
import { IBoardProps } from "./Board";
import { IPreparedBoardItems } from "./BoardItem";
import { TBoardLanes } from "./BoardLane";
import MobileBoardLane from "./MobileBoardLane";
import {
    ComponentEventHandler,
    Flex,
    MenuProps,
    ProviderConsumer as FluentUIThemeConsumer,
} from "@fluentui/react-northstar";
import { prepareBoardItems } from "./boardUtils";
import Tabs from "tabs/Tabs";
import { Tab } from "shared/models/Tab";
import styles from "./mobileBoard.module.scss";

const MobileBoard: React.FC<IBoardProps> = (props: IBoardProps) => {
    const [arrangedLanes, setStateArrangedLanes] = useState<TBoardLanes>(props.lanes);
    const [arrangedItems, setStateArrangedItems] = useState<IPreparedBoardItems>(
        prepareBoardItems(props.items, props.lanes)
    );
    const [laneKey, setLaneKey] = useState<string>(Object.keys(arrangedLanes)[0]);

    useEffect(() => {
        setStateArrangedItems(prepareBoardItems(props.items, props.lanes));
    }, [props.items]);

    useEffect(() => {
        setStateArrangedLanes(props.lanes);
    }, [props.lanes]);

    const handleOnActiveIndexChange: ComponentEventHandler<MenuProps> = (_, data) => {
        if (data?.activeIndex === undefined) {
            return;
        }

        setLaneKey(Object.keys(arrangedLanes)[Number(data.activeIndex)]);
    };

    const prepareMenuItems = () => {
        let items: Tab[] = [];

        Object.keys(arrangedLanes).map((laneKey, laneIndex) => {
            items.push({
                key: `${laneIndex}`,
                content: `${arrangedLanes[laneKey].title} (${arrangedItems[laneKey].length})`,
            });
        });

        return items;
    };

    return (
        <FluentUIThemeConsumer
            render={(globalTheme) => {
                const { t, rtl } = globalTheme.siteVariables;
                return (
                    <Flex className={styles.wrapper} column gap="gap.medium">
                        <Tabs
                            additionalClassName={styles.tabs}
                            activeTab={0}
                            items={prepareMenuItems()}
                            onActiveIndexChange={handleOnActiveIndexChange}
                        />
                        <MobileBoardLane
                            preparedItems={arrangedItems[laneKey]}
                            users={props.users}
                            t={t}
                            onItemClick={props.onShowTaskDetails}
                            boardItemCardLayout={props.boardItemCardLayout!}
                            laneKey={laneKey}
                            rtl={rtl}
                            chosenTaskId={0}
                            placeholderPosition={null}
                        />
                    </Flex>
                );
            }}
        />
    );
};

export default MobileBoard;
